// pp-compra-rapida.js — «Compra Rápida» del portal (/pages/cliente-compra-rapida).
//
// Escoges una categoría del menú «Productos» (o una subcategoría), o escribes
// en el buscador, y aparecen sus tarjetas, que pinta Liquid por Section
// Rendering:
//   GET /collections/<handle>?section_id=pp-compra-rapida-grid&page=N
//   GET /search?q=<texto>&type=product&…&section_id=pp-compra-rapida-grid&page=N
// AQUÍ NO SE PINTA NINGUNA TARJETA NI SE CALCULA UN PRECIO: la tarjeta es
// pp-product-card (la de las colecciones de la tienda) y pp-product-card.js la
// activa sola al aparecer (MutationObserver), con su «− N +» y su agregar al
// carrito. Este archivo solo trae el HTML y lo acomoda.
//
// 4-oct-2026 (Padrino): buscador que filtra mientras escribes; flechas en las
// filas de categorías (no se notaba que se deslizaban); picar la foto o el
// nombre abre la ficha de Paco 3.0 ENCIMA (Esc te regresa a tu lista); y
// «Repetir mi última compra» con su cantidad editable.
(function () {
  'use strict';

  var SECCION = 'pp-compra-rapida-grid';
  var LLAVE_RECUERDO = 'pp-compra-rapida:coleccion';
  var MIN_BUSQUEDA = 2;

  // ── Puras (las prueba tests/compra-rapida.test.mjs) ─────────────────────

  // «handle|Título~handle|Título» → [{handle, titulo}]. Lo que no traiga las
  // dos mitades se tira (un botón sin handle llevaría a /collections/).
  function hijasDe(texto) {
    return String(texto || '').split('~').map(function (par) {
      var i = par.indexOf('|');
      if (i < 1) return null;
      var handle = par.slice(0, i).trim();
      var titulo = par.slice(i + 1).trim();
      return /^[a-z0-9-]+$/.test(handle) && titulo ? { handle: handle, titulo: titulo } : null;
    }).filter(Boolean);
  }

  function urlDe(handle, pagina) {
    return '/collections/' + encodeURIComponent(handle) + '?section_id=' + SECCION + '&page=' + (pagina || 1);
  }

  // prefix=last: «caja 30» encuentra «cajas 30x25…» mientras escribe.
  function urlBusqueda(texto, pagina) {
    return '/search?q=' + encodeURIComponent(texto) + '&type=product&options%5Bprefix%5D=last&section_id=' +
      SECCION + '&page=' + (pagina || 1);
  }

  // El handle del producto desde el enlace de la tarjeta (relativo o absoluto,
  // con o sin colección delante y con ?variant=). null si no es un producto.
  function handleDeEnlace(href) {
    var m = /\/products\/([a-z0-9][a-z0-9-]*)(?:[/?#]|$)/i.exec(String(href || ''));
    return m ? m[1].toLowerCase() : null;
  }

  function cantidadValida(v) {
    var n = Math.floor(Number(v));
    return isFinite(n) && n > 0 ? n : 0;
  }

  // [{id, cantidad}] → items de /cart/add.js: sin ceros y con la misma
  // variante sumada (un pedido puede traerla en dos renglones).
  function lineasParaCarrito(lineas) {
    var orden = [];
    var por = {};
    (lineas || []).forEach(function (l) {
      var id = String(l && l.id || '');
      var n = cantidadValida(l && l.cantidad);
      if (!/^\d+$/.test(id) || !n) return;
      if (!por[id]) { por[id] = 0; orden.push(id); }
      por[id] += n;
    });
    return orden.map(function (id) { return { id: Number(id), quantity: por[id] }; });
  }

  var puras = {
    hijasDe: hijasDe, urlDe: urlDe, urlBusqueda: urlBusqueda,
    handleDeEnlace: handleDeEnlace, cantidadValida: cantidadValida, lineasParaCarrito: lineasParaCarrito
  };
  if (typeof window !== 'undefined') window.PPCompraRapida = puras;
  if (typeof document === 'undefined') return;

  // ── DOM ─────────────────────────────────────────────────────────────────

  var raiz = document.querySelector('[data-pp-cr]');
  if (!raiz) return;
  var chips = Array.prototype.slice.call(raiz.querySelectorAll('[data-pp-cr-coleccion]'));
  var cajaSub = raiz.querySelector('[data-pp-cr-subcategorias]');
  var resultados = raiz.querySelector('[data-pp-cr-resultados]');
  var esqueleto = raiz.querySelector('[data-pp-cr-esqueleto]');
  var aviso = raiz.querySelector('[data-pp-cr-aviso]');
  var btnMas = raiz.querySelector('[data-pp-cr-mas]');
  var buscador = document.querySelector('[data-pp-cr-buscar]');
  var T = {
    vacio: raiz.getAttribute('data-t-vacio'), error: raiz.getAttribute('data-t-error'), todo: raiz.getAttribute('data-t-todo'),
    sinResultados: raiz.getAttribute('data-t-sin-resultados') || '',
    errorCarrito: raiz.getAttribute('data-t-error-carrito') || ''
  };
  if (!chips.length || !resultados) return;

  var fuente = null;      // {tipo:'coleccion', handle} | {tipo:'busqueda', texto}
  var coleccion = null;   // la última colección escogida (a ella se regresa al borrar la búsqueda)
  var categoria = null;   // el botón de arriba que la contiene
  var siguiente = null;   // página siguiente o null
  var pedido = 0;         // para descartar respuestas viejas si el cliente pica rápido

  function marcar(lista, handle) {
    lista.forEach(function (b) {
      var si = b.getAttribute('data-pp-cr-coleccion') === handle;
      b.classList.toggle('is-activo', si);
      b.setAttribute('aria-selected', si ? 'true' : 'false');
      if (si && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  function decir(texto) {
    if (!aviso) return;
    aviso.textContent = texto || '';
    aviso.hidden = !texto;
  }

  function urlDeFuente(f, pagina) {
    return f.tipo === 'busqueda' ? urlBusqueda(f.texto, pagina) : urlDe(f.handle, pagina);
  }

  function cargar(f, pagina) {
    var mio = ++pedido;
    if (pagina === 1) {
      resultados.textContent = '';
      if (esqueleto) esqueleto.hidden = false;
    }
    if (btnMas) { btnMas.hidden = true; btnMas.disabled = true; }
    decir('');
    return fetch(urlDeFuente(f, pagina), { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        if (mio !== pedido) return;   // el cliente ya escogió otra cosa
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var rejilla = doc.querySelector('[data-pp-cr-grid]');
        var lista = rejilla && rejilla.querySelector('ul');
        var hay = lista && lista.children.length;
        if (pagina === 1) {
          if (!hay) {
            if (f.tipo === 'busqueda') { decir(T.sinResultados.replace('__Q__', f.texto)); return; }
            // Las categorías «hub» (p.ej. Cajas de Cartón) solo agrupan
            // subcolecciones y no traen productos propios: se abre la primera
            // subcategoría en vez de enseñar «sin productos».
            var primera = cajaSub && !cajaSub.hidden && cajaSub.querySelector('[data-pp-cr-coleccion]:not([data-pp-cr-todo])');
            if (primera && primera.getAttribute('data-pp-cr-coleccion') !== f.handle) {
              var todo = cajaSub.querySelector('[data-pp-cr-todo]');
              if (todo && todo.getAttribute('data-pp-cr-coleccion') === f.handle) todo.remove();
              escoger(primera.getAttribute('data-pp-cr-coleccion'), false);
              return;
            }
            decir(T.vacio);
            return;
          }
          resultados.appendChild(lista);
        } else if (hay) {
          var existente = resultados.querySelector('ul');
          Array.prototype.slice.call(lista.children).forEach(function (li) { existente.appendChild(li); });
        }
        var sig = rejilla && rejilla.getAttribute('data-pp-cr-siguiente');
        siguiente = sig ? Number(sig) : null;
        if (btnMas) { btnMas.hidden = !siguiente; btnMas.disabled = false; }
      })
      .catch(function () {
        if (mio !== pedido) return;
        decir(T.error);
        if (btnMas && siguiente) { btnMas.hidden = false; btnMas.disabled = false; }
      })
      .then(function () { if (mio === pedido && esqueleto) esqueleto.hidden = true; });
  }

  function pintarSub(chip) {
    if (!cajaSub) return;
    var hijas = hijasDe(chip.getAttribute('data-pp-cr-hijas'));
    cajaSub.textContent = '';
    cajaSub.scrollLeft = 0;
    if (!hijas.length) { cajaSub.hidden = true; refrescarCarriles(); return; }
    var padre = chip.getAttribute('data-pp-cr-coleccion');
    var todas = [{ handle: padre, titulo: T.todo }].concat(hijas);
    todas.forEach(function (h) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pp-cr__sub';
      b.setAttribute('data-pp-cr-coleccion', h.handle);
      if (h.handle === padre) b.setAttribute('data-pp-cr-todo', '');
      b.textContent = h.titulo;
      b.addEventListener('click', function () { escoger(h.handle, false); });
      cajaSub.appendChild(b);
    });
    cajaSub.hidden = false;
    refrescarCarriles();
  }

  function escoger(handle, esCategoria) {
    if (buscador && buscador.value) buscador.value = '';
    if (esCategoria) {
      var chip = chips.filter(function (c) { return c.getAttribute('data-pp-cr-coleccion') === handle; })[0];
      if (chip) { marcar(chips, handle); pintarSub(chip); categoria = handle; }
    } else if (cajaSub && cajaSub.hidden && cajaSub.children.length) {
      cajaSub.hidden = false;
      refrescarCarriles();
    }
    if (cajaSub) marcar(Array.prototype.slice.call(cajaSub.querySelectorAll('[data-pp-cr-coleccion]')), handle);
    coleccion = handle;
    fuente = { tipo: 'coleccion', handle: handle };
    siguiente = null;
    try { localStorage.setItem(LLAVE_RECUERDO, handle); } catch (e) {}
    cargar(fuente, 1);
  }

  // ── Buscador ────────────────────────────────────────────────────────────
  // Mientras hay texto, la rejilla es de la búsqueda y ninguna categoría se ve
  // escogida; al borrarlo se regresa a la categoría que tenía.
  var temporizador = null;
  function buscar() {
    var texto = buscador.value.trim();
    if (texto.length < MIN_BUSQUEDA) {
      if (fuente && fuente.tipo === 'busqueda' && coleccion) {
        if (coleccion === categoria) { escoger(coleccion, true); } else { marcar(chips, categoria); escoger(coleccion, false); }
      }
      return;
    }
    if (fuente && fuente.tipo === 'busqueda' && fuente.texto === texto) return;
    marcar(chips, null);
    if (cajaSub) { cajaSub.hidden = true; refrescarCarriles(); }
    fuente = { tipo: 'busqueda', texto: texto };
    siguiente = null;
    cargar(fuente, 1);
  }
  if (buscador) {
    buscador.addEventListener('input', function () {
      clearTimeout(temporizador);
      temporizador = setTimeout(buscar, 280);
    });
    buscador.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(temporizador); buscar(); }
    });
  }

  // ── Carriles con flechas ────────────────────────────────────────────────
  // Cada fila se desliza de lado; las flechas solo salen hacia donde HAY más,
  // y el carril marca data-mas-izq / data-mas-der para desvanecer ese borde.
  var carriles = Array.prototype.slice.call(raiz.querySelectorAll('[data-pp-cr-carril]')).map(function (c) {
    return {
      caja: c,
      fila: c.querySelector('.pp-cr__categorias, .pp-cr__subcategorias'),
      izq: c.querySelector('[data-pp-cr-flecha="-1"]'),
      der: c.querySelector('[data-pp-cr-flecha="1"]')
    };
  }).filter(function (c) { return c.fila; });

  function refrescarCarril(c) {
    var max = c.fila.scrollWidth - c.fila.clientWidth;
    var hayIzq = max > 2 && c.fila.scrollLeft > 2;
    var hayDer = max > 2 && c.fila.scrollLeft < max - 2;
    if (c.izq) c.izq.hidden = !hayIzq;
    if (c.der) c.der.hidden = !hayDer;
    c.caja.toggleAttribute('data-mas-izq', hayIzq);
    c.caja.toggleAttribute('data-mas-der', hayDer);
  }
  function refrescarCarriles() { carriles.forEach(refrescarCarril); }

  carriles.forEach(function (c) {
    c.fila.addEventListener('scroll', function () { refrescarCarril(c); }, { passive: true });
    [c.izq, c.der].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function () {
        var dir = Number(b.getAttribute('data-pp-cr-flecha'));
        c.fila.scrollBy({ left: dir * Math.max(160, c.fila.clientWidth * 0.7), behavior: 'smooth' });
      });
    });
  });
  window.addEventListener('resize', refrescarCarriles);

  // ── Vista rápida: la ficha de Paco 3.0 encima de la página ───────────────
  // Se abre Paco (pp-assistant:open) y se le pide la ficha del producto
  // (PPPaco3.abrirFicha): la misma de su pantalla completa, con el precio del
  // pacto y la tabla de volumen. Esc cierra a Paco y quedas en tu lista. Si
  // Paco 3.0 no está en la página o no carga a tiempo, el enlace hace lo de
  // siempre: lleva a la ficha del producto.
  function pacoV3() { return document.querySelector('pp-assistant.pp-assistant--v3'); }

  function esperarFicha(intentos, listo, nada) {
    // Paco abierto DE VERDAD (open() espera sus estilos y al terminar se va
    // a la pestaña Chat): pedir la ficha antes la dejaba escondida en celular.
    if (window.PPPaco3 && typeof window.PPPaco3.abrirFicha === 'function' &&
        document.body.classList.contains('pp-assistant-open')) { listo(); return; }
    if (intentos <= 0) { nada(); return; }
    setTimeout(function () { esperarFicha(intentos - 1, listo, nada); }, 100);
  }

  function vistaRapida(handle, href) {
    document.dispatchEvent(new CustomEvent('pp-assistant:open', { detail: {} }));
    esperarFicha(60, function () {
      window.PPPaco3.abrirFicha(handle);
      // En celular (<1000px) Paco abre en la pestaña Chat y la ficha vive en
      // la de Productos: se cambia, como hace su «Ver N resultados».
      var el = window.PPPaco3.el;
      if (window.innerWidth < 1000 && el && typeof el._switchTab === 'function') el._switchTab('products');
    }, function () {
      window.location.href = href;
    });
  }

  resultados.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a.pp-prod-card__cover-link, a.pp-prod-card__title-link, a.pp-prod-card__info-link');
    if (!a || !pacoV3()) return;
    var handle = handleDeEnlace(a.getAttribute('href'));
    if (!handle) return;
    e.preventDefault();
    vistaRapida(handle, a.href);
  });

  // ── Repetir mi última compra ────────────────────────────────────────────
  var dialogo = document.querySelector('[data-pp-cr-repetir]');
  var abrirRepetir = document.querySelector('[data-pp-cr-repetir-abrir]');

  function avisarCarrito() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        // Las dos familias de oyentes del tema: la tienda (pp:cart-updated)
        // y Paco / Te Toca (pp:cart:updated).
        document.dispatchEvent(new CustomEvent('pp:cart-updated', { detail: cart || undefined }));
        document.dispatchEvent(new CustomEvent('pp:cart:updated', { detail: cart || undefined }));
      })
      .catch(function () {});
  }

  function agregar(items) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok; }, function () { return false; });
  }

  if (dialogo && abrirRepetir && typeof dialogo.showModal === 'function') {
    var avisoRep = dialogo.querySelector('[data-pp-cr-repetir-aviso]');
    var btnAgregar = dialogo.querySelector('[data-pp-cr-repetir-agregar]');
    var renglones = Array.prototype.slice.call(dialogo.querySelectorAll('[data-pp-cr-repetir-variante]'));
    var decirRep = function (t) { if (!avisoRep) return; avisoRep.textContent = t || ''; avisoRep.hidden = !t; };

    abrirRepetir.addEventListener('click', function () { decirRep(''); dialogo.showModal(); });
    Array.prototype.forEach.call(dialogo.querySelectorAll('[data-pp-cr-repetir-cerrar]'), function (b) {
      b.addEventListener('click', function () { dialogo.close(); });
    });
    // Clic en el fondo (fuera de la caja) cierra.
    dialogo.addEventListener('click', function (e) { if (e.target === dialogo) dialogo.close(); });

    renglones.forEach(function (li) {
      var input = li.querySelector('[data-pp-cr-repetir-cantidad]');
      Array.prototype.forEach.call(li.querySelectorAll('[data-pp-cr-paso]'), function (b) {
        b.addEventListener('click', function () {
          var n = cantidadValida(input.value) + Number(b.getAttribute('data-pp-cr-paso'));
          input.value = String(Math.max(0, n));
          li.classList.toggle('is-cero', !cantidadValida(input.value));
        });
      });
      input.addEventListener('input', function () { li.classList.toggle('is-cero', !cantidadValida(input.value)); });
    });
    // 6-oct-2026 (Padrino): la caja personalizada con su recibo vuelve CON su
    // personalización, tras confirmar su diseño: el mockup que aprobó y
    // «Dejar igual» / «Cambiar algo» (PPPersonalizacion.tarjetaDeRecompra).
    // Sin el módulo, se queda la liga a «Mis diseños» que ya venía en el Liquid.
    var persos = Array.prototype.slice.call(dialogo.querySelectorAll('[data-pp-cr-perso]'));
    var montarPersos = function () {
      var P = window.PPPersonalizacion;
      if (!P) return;
      persos.forEach(function (caja) {
        if (caja.getAttribute('data-pp-cr-perso') === 'listo') return;
        var atributos;
        try { atributos = JSON.parse(caja.getAttribute('data-atributos') || '[]'); } catch (_) { return; }
        caja.setAttribute('data-pp-cr-perso', 'listo');
        caja.textContent = '';
        caja.appendChild(P.tarjetaDeRecompra({
          variant_id: Number(caja.getAttribute('data-variante')),
          quantity: Number(caja.getAttribute('data-cantidad')) || 1,
          atributos: atributos,
          titulo: caja.getAttribute('data-titulo') || ''
        }, function (ok) { if (ok) avisarCarrito(); }));
      });
    };
    abrirRepetir.addEventListener('click', montarPersos);
    if (!renglones.length && btnAgregar) btnAgregar.disabled = true;

    dialogo.querySelector('[data-pp-cr-repetir-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var lineas = renglones.map(function (li) {
        return {
          id: li.getAttribute('data-pp-cr-repetir-variante'),
          cantidad: li.querySelector('[data-pp-cr-repetir-cantidad]').value,
          nombre: (li.querySelector('.pp-cr-repetir__nombre') || {}).textContent || ''
        };
      });
      var items = lineasParaCarrito(lineas);
      if (!items.length) return;
      btnAgregar.disabled = true;
      decirRep('');
      agregar(items).then(function (ok) {
        if (ok) return { fallaron: [] };
        // Todo o nada en /cart/add.js: si uno no entra (existencias, reglas de
        // cantidad) se intenta renglón por renglón para no perder los demás.
        var fallaron = [];
        return items.reduce(function (p, it) {
          return p.then(function () {
            return agregar([it]).then(function (bien) {
              if (!bien) {
                var l = lineas.filter(function (x) { return String(x.id) === String(it.id); })[0];
                fallaron.push(l ? l.nombre.trim() : String(it.id));
              }
            });
          });
        }, Promise.resolve()).then(function () { return { fallaron: fallaron, todos: fallaron.length === items.length }; });
      }).then(function (res) {
        btnAgregar.disabled = false;
        if (res.todos) { decirRep(T.errorCarrito); return; }
        return avisarCarrito().then(function () {
          if (res.fallaron.length) {
            decirRep(T.errorCarrito + ' ' + res.fallaron.join(' · '));
            return;
          }
          dialogo.close();
          document.dispatchEvent(new CustomEvent('pp:cart-drawer:open', { detail: {} }));
        });
      });
    });
    // «Repetir Orden» del Inicio manda aquí (?repetir=1) cuando el pedido trae
    // algo personalizado: aquí se confirma su diseño.
    if (/[?&]repetir=1(&|$)/.test(window.location.search)) { decirRep(''); montarPersos(); dialogo.showModal(); }
  } else if (abrirRepetir) {
    abrirRepetir.hidden = true;
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function () { escoger(c.getAttribute('data-pp-cr-coleccion'), true); });
  });
  if (btnMas) btnMas.addEventListener('click', function () { if (fuente && siguiente) cargar(fuente, siguiente); });

  // Arranca en la última categoría que usó (si sigue en el menú), si no en la primera.
  var recordada = null;
  try { recordada = localStorage.getItem(LLAVE_RECUERDO); } catch (e) {}
  var inicial = chips.filter(function (c) { return c.getAttribute('data-pp-cr-coleccion') === recordada; })[0] || chips[0];
  escoger(inicial.getAttribute('data-pp-cr-coleccion'), true);
  refrescarCarriles();
})();
